import AbstractRepository from "@/repositories/AbstractRepository";

export default class ListSfSupportRepository extends AbstractRepository {
    protected static resource: string = "ptf-monocle-listdefinition-support";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
    ];
}
